import React from 'react'
import DynamicTable from '../../components/ReusableComponent/DynamicTable'
import Studentscomponet from '../../components/Students/Studentscomponet'

const Students = () => {
  return (
    <div>
        <Studentscomponet />
    </div>
  )
}

export default Students